import { createSlice } from '@reduxjs/toolkit';

const calculateFutureDate = (days: number | null) => {
  if (days === null) return null;
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date.toISOString();
};

// const calculateFutureDateInMinutes = (minutes: number | null) => {
//   if (minutes === null) return null;
//   const date = new Date();
//   date.setMinutes(date.getMinutes() + minutes);
//   return date.toISOString();
// }; Metodo de Teste Interno.

type ProfileState = {
  hasCompletedOnboarding: boolean;
  hasCompletedNavigationTour: boolean;
  futureDays: string | null;
  shouldItOpenNotificationModal: boolean;
};

const initialState: ProfileState = {
  hasCompletedOnboarding: false,
  hasCompletedNavigationTour: false,
  futureDays: calculateFutureDate(7),
  shouldItOpenNotificationModal: false,
};

const userDeviceSessionData = createSlice({
  name: 'userDeviceData',
  initialState,
  reducers: {
    setHasCompletedOnboarding: (state) => {
      state.hasCompletedOnboarding = true;
    },
    setCleanCompletedOnboarding: (state) => {
      state.hasCompletedOnboarding = false;
    },
    setHasCompletedNavigationTour: (state) => {
      state.hasCompletedNavigationTour = true;
    },
    setCleanCompletedNavigationTour: (state) => {
      state.hasCompletedNavigationTour = false;
    },
    setForceToBeOpenNotificationModal: (state) => {
      state.shouldItOpenNotificationModal = true;
    },
    setForceToBeClosedNotificationModal: (state) => {
      state.shouldItOpenNotificationModal = false;
    },
    setFutureNotificationDate: (state, action) => {
      state.futureDays = calculateFutureDate(action.payload);
    },
    checkShouldBeOpenNotificationModal: (state) => {
      const today = new Date();
      if (state.futureDays) {
        const futureDate = new Date(state.futureDays);

        if (today >= futureDate) {
          state.shouldItOpenNotificationModal = true;
        }
      } else {
        state.futureDays = calculateFutureDate(7);
      }
    },
  },
});

export const {
  setHasCompletedOnboarding,
  setCleanCompletedOnboarding,
  setCleanCompletedNavigationTour,
  setHasCompletedNavigationTour,
  checkShouldBeOpenNotificationModal,
  setForceToBeOpenNotificationModal,
  setForceToBeClosedNotificationModal,
  setFutureNotificationDate,
} = userDeviceSessionData.actions;
export default userDeviceSessionData.reducer;
